import styled from "styled-components";

const MyDiv = styled.div`

/* =======================================
   1. SIDEBAR MAIN WRAPPERS 
======================================= */
.sidebar_wrapper {
  background-color: #FFFFFF;
  min-height: 100vh;
  height: 100vh;
  width: 237px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: block;
  overflow-x: hidden;
  transition: 0.5s;
  padding-bottom: 20px;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &:hover {
    overflow-y: auto;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f0f5f1;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #0052CC;
      border-radius: 6px;
    }
  }
}

.sidebar_collapse {
  background-color: #FFFFFF;
  min-height: 100vh;
  height: 100vh;
  width: 90px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: block;
  transition: 0.5s;
  padding-bottom: 20px;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &:hover {
    overflow-y: auto;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #E6EEFA;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #0052CC;
      border-radius: 6px;
    }
  }
}

/* =======================================
   2. COLLAPSE BUTTON 
======================================= */
.collapse-button {
  position: absolute;
  top: 30px;
  right: -10px;
  z-index: 11;
  margin-left: 2px;
  margin-bottom: 3px;

  button {
    border-radius: 8px;
    height: 28px;
    min-width: 28px;
  }
}

// .collpase_icon {
//   transform: rotate(0deg);
//   transition: 0.5s;
// }
 /* When sidebar is expanded */
.sidebar_wrapper .collapse-button button img {
  transform: rotate(0deg);   /* show < */
  transition: 0.3s;
}
 
/* When sidebar is collapsed */
.sidebar_collapse .collapse-button button img {
  transform: rotate(180deg);     /* show > */
  transition: 0.3s;
}
/* =======================================
   3. LOGO AREA
======================================= */
.logo_wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 22px 0 22px;
}

.logo_icon {
  width: 40px;
  height: auto;
}

.logo_text {
  height: 40px;
  object-fit: contain;
  margin-top: 3px;
}

.sidebar_collapse .logo_wrapper {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

/* =======================================
   4. SIDEBAR BOXES
======================================= */
.sidebar_box {
  margin-top: 30px;
  padding: 0;

  @media(max-width:767px) {
    margin-top: 0;
    padding: 0;
  }
}

.sidebar_box_toggle {
  margin-top: 40px;
  padding: 0;
}

/* =======================================
   5. MENU ITEMS
======================================= */
.menu_box {
  margin-top: 24px;
}

.menu_item {
  display: flex;
  align-items: center;
  margin: 0 14px;
  cursor: pointer;
  transition: 0.2s ease;

  a {
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    column-gap: 12px;

    padding: 0 16px;

    font-size: 15px;
    line-height: 24px;
    font-weight: 500;

    border-radius: 10px;
    transition: 0.2s ease;
  }

}

  svg {
    width: 25px;
    height: 25px;

    path {
      fill: #FFFFFF;
    }
  }
}

.icon_size {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  object-fit: contain;
  flex-shrink: 0;
}

/* =======================================
   6. ACTIVE MENU HIGHLIGHT
======================================= */
.active_menu {
border-radius: 9px;
  transition: 0.2s;
}

.active_menu a {
  background: #4048D6;
  color: #FFFFFF !important;
}

.active_menu .icon_size {
  filter: brightness(0) invert(1);
}

/* =======================================
   7. SUBMENU
======================================= */
.submenu_wrapper {
  padding-left: 52px;       /* consistent indent */
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.submenu_item {
  font-size: 13px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  color: #000;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;                  /* bullet → text spacing */
}

// .submenu_item::before {
//   content: "•";              /* bullet */
//   font-size: 18px;
//   color: #000;
//   margin-right: 6px;
// }


.active_submenu {
  color: #0052CC !important;
  font-weight: 500;
}

`;

export default MyDiv;
